import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BeltPromotion } from '../../store/slices/beltProgressionSlice';
import { ShareBeltPromotionModal } from '../ShareBeltPromotion';

interface ShareBeltButtonProps {
  promotion: BeltPromotion;
  useModal?: boolean;
  className?: string;
  iconOnly?: boolean;
}

/**
 * ShareBeltButton component
 * 
 * @description A button that allows users to share a belt promotion
 * Either opens a modal or navigates to the share page based on useModal prop
 */
const ShareBeltButton: React.FC<ShareBeltButtonProps> = ({ 
  promotion, 
  useModal = false, 
  className = '', 
  iconOnly = false 
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleShare = () => {
    if (useModal) {
      setIsModalOpen(true);
    } else {
      navigate(`/belt-promotion/${promotion.id}/share`);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        onClick={handleShare}
        className={`flex items-center justify-center px-3 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors ${className}`}
        aria-label="Share belt promotion"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
        </svg>
        {!iconOnly && <span className="ml-2">Share Promotion</span>}
      </button>

      {useModal && (
        <ShareBeltPromotionModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          promotion={promotion}
        />
      )}
    </>
  );
};

export default ShareBeltButton;